/**
 * The enum used for increase or decrease font size
 * Used by setFontSize API
 */
// eslint-disable-next-line etc/no-const-enum
export const enum FontSizeChange {
    /**
     * Increase font size
     */
    Increase,

    /**
     * Decrease font size
     */
    Decrease,
}
